module.exports = __webpack_public_path__ + "img/destination-7.9c0b3e6f.svg";